import { HttpRequest, HttpEvent, HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';

import { Observable, catchError, throwError } from 'rxjs';

export const blobErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  return next(req).pipe(
    catchError((err) => {
      if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.error.type === 'application/json') {
        const errorContent = err.error;
        return new Promise<HttpEvent<HttpErrorResponse>>(async (_, reject) => {
          const errorText = await errorContent.text();
          reject(new HttpErrorResponse({ ...err, error: errorText, url: err.url ?? undefined }));
        });
      }
      return throwError(() => err);
    }),
  );
};
